"use client";
import React from "react";
import { motion } from "framer-motion";

import { ArrowRight } from "lucide-react";
import Image from "next/image";

const SeoCTR = () => {
  return (
    <section className="px-5 pt-20 md:pt-28 pb-16 sm:px-6 lg:px-20">
      {/* hero */}
      <div className="relative overflow-hidden rounded-[16px] bg-white ring-1 ring-[#000000]/[8%]">
        <div className="grid grid-cols-1 items-center lg:grid-cols-2">
          {/* left */}
          <div className="order-2 p-4 md:p-12 lg:order-1 lg:px-12">
            <h2 className="solution-sub-heading">
              Want better CTRs and lower CPC on Google?
            </h2>

            <p className="body-secondary-text mt-3">
              Write smarter, search-aligned copy with Imagive.
              <br />
              No credit card required to start.
            </p>

            <div className="mt-12 flex flex-col gap-3 sm:flex-row">
              <a
                href="https://app.imagive.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary group inline-flex items-center justify-center gap-2"
              >
                Start creating - it&apos;s free
                <ArrowRight
                  size={18}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </a>
              <a
                href="https://app.imagive.ai/"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-secondary inline-flex items-center justify-center"
              >
                Schedule a demo
              </a>
            </div>
          </div>

          {/* right */}
          <div className="relative h-[280px] sm:h-[340px] lg:order-2 order-1 lg:h-[300px] xl:h-[360px]">
            <Image
              src="/assets/platforms/seo/seoCTR.svg"
              alt="Google ad preview with CTR and CPC performance metrics"
              fill
              sizes="(max-width: 1024px) 100vw, 50vw"
              className="object-contain object-center lg:object-right"
              priority
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default SeoCTR;
